import SelecStands from "./select-stands";

export default SelecStands;